(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vs-autumn-street"] && !Shopify.designMode) return;
  try {
    
(() => {
if(customElements.get('vs-autumn-street'))return;
function mount(root){


const footer = root;
const toggle = root.querySelector('.vas-motion-toggle');
const label = root.querySelector('.vas-motion-toggle__text');
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
let manualPause = root.dataset.autoplay !== 'true';
let inView = false;
let destroyed = false;
const events = new AbortController();
let sceneTime = 0;
let frameId = 0;
let previousFrame = null;
const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
const mix = (a, b, t) => a + (b - a) * t;
const smooth = t => t * t * (3 - 2 * t);
const figureScaleAt = groundY => .82 * (groundY - 445) / 83;
let revealFrame = 0;
function updateReveal(){
 revealFrame = 0;
 if(destroyed)return;
 if(reduced.matches){root.style.setProperty('--vas-scene-reveal','1');return;}
 const viewport = window.innerHeight || document.documentElement.clientHeight;
 const top = root.getBoundingClientRect().top;
 const progress = clamp((viewport*.92-top)/(viewport*.54));
 root.style.setProperty('--vas-scene-reveal',smooth(progress).toFixed(3));
}
function scheduleReveal(){if(!revealFrame)revealFrame=requestAnimationFrame(updateReveal);}
window.addEventListener('scroll',scheduleReveal,{passive:true,signal:events.signal});
window.addEventListener('resize',scheduleReveal,{signal:events.signal});
const journeys = [
 {near:[700,517], far:[884,489], bend:[789,501], walk:32, pause:6.5, offset:13, stride:21},
 {near:[1358,541], far:[1294,525], bend:[1330,530], walk:12, pause:8, offset:27, stride:20},
 {near:[946,485], far:[1021,475], bend:[982,479], walk:24, pause:5.5, offset:18, stride:20}
];
for(const c of journeys){
 c.distance=[0];let previous=pathPosition(c,0);
 for(let i=1;i<=160;i++){
  const point=pathPosition(c,i/160);
  c.distance.push(c.distance[i-1]+Math.hypot(point.x-previous.x,point.y-previous.y)/((point.s+previous.s)/2));
  previous=point;
 }
}
const people = [...root.querySelectorAll('.vas-shopper')].map((node,i) => ({
 node, cfg:journeys[i], turn:node.querySelector('.vas-person-turn'), body:node.querySelector('.vas-person-body'),
 front:[...node.querySelectorAll('.vas-front-details,.vas-front-face')], back:node.querySelector('.vas-coat-back-detail'),
 legs:[node.querySelector('.vas-leg-left'),node.querySelector('.vas-leg-right')],
 shoes:[node.querySelector('.vas-shoe-left'),node.querySelector('.vas-shoe-right')],
 arms:[node.querySelector('.vas-arm-left'),node.querySelector('.vas-arm-right')],
 hands:[node.querySelector('.vas-hand-left'),node.querySelector('.vas-hand-right')], bag:node.querySelector('.vas-bag-left')
}));

function pathPosition(cfg,u){
 const v=1-u;
 const y=v*v*cfg.near[1]+2*v*u*cfg.bend[1]+u*u*cfg.far[1];
 return {x:v*v*cfg.near[0]+2*v*u*cfg.bend[0]+u*u*cfg.far[0],
 y,s:figureScaleAt(y)};
}
function travelProgress(t){
 const ramp=.07;
 const eased=t<ramp?t*t/(2*ramp):t>1-ramp?1-ramp-(1-t)*(1-t)/(2*ramp):t-ramp/2;
 return (1-Math.exp(-.48*eased/(1-ramp)))/(1-Math.exp(-.48));
}
function posePerson(person,time,still=false){
 const c=person.cfg, turnTime=2.6;
 const cycle=c.walk*2+c.pause*2+turnTime*2;
 const t=(time+c.offset)%cycle;
 let u=0,face=0,turnWidth=1,moving=false,direction=1,walkFraction=0;
 if(t<c.walk){walkFraction=t/c.walk;u=travelProgress(walkFraction);moving=true;}
 else if(t<c.walk+c.pause){u=1;}
 else if(t<c.walk+c.pause+turnTime){
  u=1;const q=(t-c.walk-c.pause)/turnTime;face=smooth(q);turnWidth=.30+.70*Math.abs(Math.cos(Math.PI*q));
 }else if(t<c.walk*2+c.pause+turnTime){
  walkFraction=(t-c.walk-c.pause-turnTime)/c.walk;u=travelProgress(1-walkFraction);face=1;direction=-1;moving=true;
 }else if(t<c.walk*2+c.pause*2+turnTime){u=0;face=1;}
 else{const q=(t-c.walk*2-c.pause*2-turnTime)/turnTime;face=1-smooth(q);turnWidth=.30+.70*Math.abs(Math.cos(Math.PI*q));}
 const pos=pathPosition(c,u);
 person.node.setAttribute('transform',`translate(${pos.x.toFixed(3)} ${pos.y.toFixed(3)}) scale(${pos.s.toFixed(4)})`);
 person.turn.setAttribute('transform',`scale(${turnWidth.toFixed(3)} 1)`);
 person.front.forEach(n=>n.setAttribute('opacity',face.toFixed(3)));
 person.back.setAttribute('opacity',(1-face).toFixed(3));
 const sample=u*160,index=Math.min(159,Math.floor(sample));
 const localDistance=mix(c.distance[index],c.distance[index+1],sample-index);
 const phase=localDistance*.55/c.stride;
 const tx=2*(1-u)*(c.bend[0]-c.near[0])+2*u*(c.far[0]-c.bend[0]);
 const ty=2*(1-u)*(c.bend[1]-c.near[1])+2*u*(c.far[1]-c.bend[1]);
 const tangentLength=Math.hypot(tx,ty);
 const dx=tx/tangentLength*direction,dy=ty/tangentLength*direction;
 const gait=moving&&!still?smooth(clamp(Math.min(walkFraction,1-walkFraction)/.055)):0;
 const bob=gait*Math.sin(phase*Math.PI*4)*.50;
 person.body.setAttribute('transform',`translate(0 ${bob.toFixed(3)})`);
 for(let leg=0;leg<2;leg++){
  const q=((direction*phase+(leg?.5:0))%1+1)%1;
  let along=0,lift=0;
  if(gait){if(q<.55){along=(.5-q/.55)*c.stride;}else{const swing=(q-.55)/.45;along=(-.5+smooth(swing))*c.stride;lift=Math.sin(Math.PI*swing)*3.5;}}
  const hip=leg?4:-4;
  const footX=hip+dx*along*gait;
  const footY=dy*along*gait-lift*gait-bob;
  const kneeX=mix(hip,footX,.46)+(leg?1:-1)*1.3;
  const kneeY=-15+Math.min(0,footY)*.35;
  person.legs[leg].setAttribute('d',`M${hip} -30Q${kneeX.toFixed(2)} ${kneeY.toFixed(2)} ${footX.toFixed(2)} ${footY.toFixed(2)}`);
  person.shoes[leg].setAttribute('d',`M${(footX-2).toFixed(2)} ${footY.toFixed(2)}l4.7 ${face>.5?1.1:-.7}`);
  const swing=gait*Math.sin(q*Math.PI*2)*2.8;
  const handX=(leg?11:-12)+swing*.3,handY=-33+swing;
  person.arms[leg].setAttribute('d',`M${leg?9:-9} -56Q${leg?13:-13} -44 ${handX.toFixed(2)} ${handY.toFixed(2)}`);
  person.hands[leg].setAttribute('cx',handX.toFixed(2));person.hands[leg].setAttribute('cy',handY.toFixed(2));
  if(!leg)person.bag.setAttribute('transform',`translate(${(swing*.3).toFixed(2)} ${swing.toFixed(2)}) rotate(${(swing*1.7).toFixed(2)} -12 -33)`);
 }
}
const zaps=[...root.querySelectorAll('[data-zap]')].map(node=>({
 line:node.querySelector('.vas-shop-zap'),trace:node.querySelector('.vas-zap-trace'),
 start:node.querySelector('[data-end="start"]'),finish:node.querySelector('[data-end="finish"]'),
 left:Number(node.getAttribute('data-left')),right:Number(node.getAttribute('data-right'))
}));
let visibleZaps=zaps;
function updateVisibleZaps(){
 const {width,height}=root.querySelector('.vas-world').getBoundingClientRect();
 const scale=Math.max(width/2172,height/724);
 const left=(2172-width/scale)/2,right=2172-left;
 visibleZaps=zaps.filter(z=>Math.max(0,Math.min(right,z.right)-Math.max(left,z.left))/(z.right-z.left)>.75);
 if(!visibleZaps.length)visibleZaps=[zaps[0]];
}
function drawZaps(time,off=false){
 const elapsed=time-.65;
 const slot=Math.max(0,Math.floor(elapsed/9));
 const p=(elapsed%9)/1.9;
 const selected=visibleZaps[slot%visibleZaps.length];
 for(const z of zaps){
  const active=!off&&z===selected&&elapsed>=0&&p>=0&&p<=1;
  const glow=active?Math.sin(Math.PI*p):0;
  z.line.style.opacity=String(Math.min(1,glow*1.6));
  z.trace.style.opacity=String(glow*.24);
  z.line.style.strokeDashoffset=String(.26-p*1.26);
  z.start.style.opacity=active?String(Math.max(0,1-p*3)*.95):'0';
  z.finish.style.opacity=active?String(Math.max(0,1-Math.abs(p-.8)*5)*.95):'0';
 }
}
function drawScene(){people.forEach(p=>posePerson(p,sceneTime,reduced.matches));drawZaps(sceneTime,reduced.matches);}
function tick(now){
 frameId=0;
 if(previousFrame!==null)sceneTime+=Math.min((now-previousFrame)/1000,.08);
 previousFrame=now;drawScene();
 if(!destroyed&&!manualPause&&!reduced.matches&&!document.hidden&&inView)frameId=requestAnimationFrame(tick);
}
function syncMotion(){
 const paused=reduced.matches||manualPause||document.hidden||!inView;
 footer.classList.toggle('is-paused',paused);
 toggle.disabled=reduced.matches;
 toggle.setAttribute('aria-pressed',String(paused));
 toggle.setAttribute('aria-label',reduced.matches?root.dataset.off:paused?root.dataset.play:root.dataset.pause);
 label.textContent=reduced.matches?root.dataset.off:paused?root.dataset.play:root.dataset.pause;
 if(frameId)cancelAnimationFrame(frameId);
 frameId=0;previousFrame=null;drawScene();
 if(!paused&&!destroyed)frameId=requestAnimationFrame(tick);
}

let linkedFooterWrapper=null;
let compositionResize=null;
let compositionFrame=0;
function clearComposition(){
 if(compositionResize)compositionResize.disconnect();
 compositionResize=null;
 if(linkedFooterWrapper)linkedFooterWrapper.style.removeProperty('--vas-composite-height');
 linkedFooterWrapper=null;
 root.closest('.shopify-section')?.style.removeProperty('--vas-composite-height');
 root.style.removeProperty('--vas-links-bottom');
}
function bindComposition(){
 if(destroyed)return;
 clearComposition();
 if(root.dataset.overlayFooter!=='true')return;
 const sourceWrapper=root.closest('.shopify-section');
 const nextWrapper=sourceWrapper?.nextElementSibling;
 const existingFooter=nextWrapper?.querySelector(':scope>footer[data-vas-footer]');
 if(!existingFooter)return;
 const top=existingFooter.querySelector('[data-vas-footer-top]');
 const bottom=existingFooter.querySelector('[data-vas-footer-bottom]');
 if(!top||!bottom)return;
 linkedFooterWrapper=nextWrapper;
 function sizeComposition(){
  if(destroyed||!existingFooter.isConnected)return;
  const footerStyle=getComputedStyle(existingFooter);
  const mobile=window.matchMedia('(max-width:767px)').matches;
  const paddingTop=parseFloat(footerStyle.paddingTop)||0;
  const paddingBottom=parseFloat(footerStyle.paddingBottom)||0;
  const topHeight=top.getBoundingClientRect().height;
  const bottomHeight=bottom.getBoundingClientRect().height;
  const reveal=parseFloat(getComputedStyle(nextWrapper).getPropertyValue('--vas-reveal-height'))||(mobile?230:260);
  const minimum=Number(mobile?root.dataset.minimumMobileHeight:root.dataset.minimumHeight)||0;
  const height=Math.ceil(Math.max(minimum,topHeight+bottomHeight+paddingTop+paddingBottom+reveal));
  const value=height+'px';
  if(sourceWrapper.style.getPropertyValue('--vas-composite-height')!==value)sourceWrapper.style.setProperty('--vas-composite-height',value);
  if(nextWrapper.style.getPropertyValue('--vas-composite-height')!==value)nextWrapper.style.setProperty('--vas-composite-height',value);
  root.style.setProperty('--vas-links-bottom',Math.ceil(paddingTop+topHeight+15)+'px');
 }
 compositionResize=new ResizeObserver(sizeComposition);
 compositionResize.observe(top);compositionResize.observe(bottom);
 sizeComposition();
}
function scheduleComposition(){
 if(compositionFrame)cancelAnimationFrame(compositionFrame);
 compositionFrame=requestAnimationFrame(()=>{compositionFrame=0;bindComposition();});
}
window.addEventListener('resize',scheduleComposition,{signal:events.signal});
document.addEventListener('shopify:section:load',scheduleComposition,{signal:events.signal});
document.addEventListener('shopify:section:unload',scheduleComposition,{signal:events.signal});
document.addEventListener('shopify:section:reorder',scheduleComposition,{signal:events.signal});
bindComposition();

toggle.hidden=false;
toggle.addEventListener('click',()=>{manualPause=!manualPause;syncMotion();},{signal:events.signal});
reduced.addEventListener('change',()=>{syncMotion();scheduleReveal();},{signal:events.signal});
document.addEventListener('visibilitychange',syncMotion,{signal:events.signal});
const resizeObserver=new ResizeObserver(updateVisibleZaps);
resizeObserver.observe(root);
const visibilityObserver=new IntersectionObserver(entries=>{
 inView=entries.some(entry=>entry.isIntersecting);
 syncMotion();
},{rootMargin:'150px 0px'});
visibilityObserver.observe(root);
updateVisibleZaps();
updateReveal();
syncMotion();
return ()=>{
 destroyed=true;events.abort();visibilityObserver.disconnect();resizeObserver.disconnect();
 if(revealFrame)cancelAnimationFrame(revealFrame);
 if(compositionFrame)cancelAnimationFrame(compositionFrame);
 clearComposition();
 if(frameId)cancelAnimationFrame(frameId);
 frameId=0;previousFrame=null;
 root.classList.add('is-paused');
};

}
class VSAutumnStreet extends HTMLElement{
 connectedCallback(){
  if(this.cleanup||this.mountFrame)return;
  this.mountFrame=requestAnimationFrame(()=>{
   this.mountFrame=null;
   if(this.isConnected&&!this.cleanup)this.cleanup=mount(this);
  });
 }
 disconnectedCallback(){
  if(this.mountFrame)cancelAnimationFrame(this.mountFrame);
  this.mountFrame=null;
  if(this.cleanup)this.cleanup();
  this.cleanup=null;
 }
}
customElements.define('vs-autumn-street',VSAutumnStreet);
document.addEventListener('shopify:section:load',event=>{
 event.target.querySelectorAll('vs-autumn-street').forEach(scene=>scene.connectedCallback());
});
document.addEventListener('shopify:section:unload',event=>{
 event.target.querySelectorAll('vs-autumn-street').forEach(scene=>scene.disconnectedCallback());
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clip = n => Math.max(0, Math.min(1, n));
  const between = (n, a, b) => clip((n - a) / (b - a));
  const smooth = n => n * n * (3 - 2 * n);
  const assetBase = 'https://cdn.shopify.com/s/files/1/0986/6559/5264/t/8/assets/';
  const scripts = new Map();
  const load = (name, ready) => {
    if (ready()) return Promise.resolve();
    if (scripts.has(name)) return scripts.get(name);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = setTimeout(() => reject(new Error('Background load timed out')), 10000);
      script.src = assetBase + name;
      script.async = true;
      script.onload = () => { clearTimeout(timeout); ready() ? resolve() : reject(new Error('Background unavailable')); };
      script.onerror = () => { clearTimeout(timeout); reject(new Error('Background load failed')); };
      document.head.appendChild(script);
    });
    scripts.set(name, promise);
    return promise;
  };
  class VSOpening {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('.vs-opening__stage');
      this.words = [...root.querySelectorAll('[data-opening-word]')];
      this.phrases = [...root.querySelectorAll('[data-opening-phrase]')];
      this.support = root.querySelector('.vs-proof__actions');
      this.displacement = root.querySelector('[data-opening-displacement]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.queue = this.queue.bind(this);
      this.measure = this.measure.bind(this);
      this.configure = this.configure.bind(this);
      this.frame = 0;
      this.progress = 0;
      this.disposed = false;
      root.closest('.vs-proof').classList.add('has-smoke-opening');
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this.stage);
      const header = document.querySelector('.site-header > header');
      if (header) this.resizeObserver.observe(header);
      window.addEventListener('scroll', this.queue, { passive: true });
      window.addEventListener('resize', this.measure, { passive: true });
      this.motion.addEventListener('change', this.configure);
      this.configure();
      if (document.fonts) document.fonts.ready.then(() => { if (!this.disposed) this.measure(); });
    }
    configure() {
      const reduced = this.motion.matches;
      this.root.classList.toggle('is-scroll-ready', !reduced);
      if (reduced) {
        this.destroyEffects();
        this.root.removeAttribute('style');
        this.words.forEach(word => word.removeAttribute('style'));
        this.phrases.forEach(phrase => phrase.removeAttribute('style'));
        this.displacement.setAttribute('scale', '0');
        this.support.inert = false;
      } else {
        this.measure();
        this.loadEffects();
      }
      window.dispatchEvent(new Event('resize'));
    }
    async loadEffects() {
      if (this.loading || this.fog) return;
      this.loading = true;
      try {
        await load('three.r134.min.js', () => !!window.THREE);
        await Promise.all([
          load('vanta.fog.min.js', () => !!window.VANTA?.FOG),
          load('vanta.net.min.js', () => !!window.VANTA?.NET)
        ]);
        if (this.disposed || this.motion.matches) return;
        const shared = { THREE: window.THREE, mouseControls: false, touchControls: false, gyroControls: false, minHeight: 200, minWidth: 200 };
        this.fog = window.VANTA.FOG({
          ...shared, el: this.root.querySelector('[data-opening-fog]'), highlightColor: 0x00ec85, midtoneColor: 0xffffff,
          lowlightColor: 0x130e29, baseColor: 0x130e29, blurFactor: .4, speed: 1.3, zoom: .3, scale: 2, scaleMobile: 4
        });
        this.net = window.VANTA.NET({
          ...shared, el: this.root.querySelector('[data-opening-net]'), color: 0x00ec85, backgroundColor: 0x011127,
          points: innerWidth < 761 ? 7 : 12, maxDistance: 24, spacing: 20, scale: 1.5, scaleMobile: 2
        });
        this.fog.isOnScreen = () => this.visible && this.progress < .6 && !document.hidden;
        this.net.isOnScreen = () => this.visible && this.progress > .25 && !document.hidden;
        this.root.dataset.backgrounds = 'ready';
        this.queue();
      } catch (error) {
        this.root.dataset.backgrounds = 'fallback';
      } finally { this.loading = false; }
    }
    measure() {
      if (this.disposed || this.motion.matches) return;
      const header = document.querySelector('.site-header > header');
      this.root.style.setProperty('--opening-header-height', (header?.offsetHeight || 0) + 'px');
      this.top = this.root.getBoundingClientRect().top + scrollY;
      this.distance = Math.max(1, this.root.offsetHeight - this.stage.offsetHeight);
      this.queue();
    }
    queue() {
      if (this.frame || this.motion.matches || this.disposed) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.render(); });
    }
    render() {
      const p = clip((scrollY - this.top) / this.distance);
      this.progress = p;
      const rect = this.stage.getBoundingClientRect();
      this.visible = rect.bottom > 0 && rect.top < innerHeight;
      const fog = 1 - smooth(between(p, .16, .57));
      const network = smooth(between(p, .26, .62));
      const support = 1 - smooth(between(p, .025, .13));
      const thread = smooth(between(p, .78, .97));
      const props = { 'opening-p':p, 'fog-opacity':fog, 'fog-drift':smooth(between(p,.02,.55)), 'network-opacity':network, 'support-opacity':support, 'message-label':smooth(between(p,.46,.58)), thread, 'cue-opacity':1-smooth(between(p,.025,.15)) };
      for (const [key,value] of Object.entries(props)) this.root.style.setProperty(`--${key}`,value.toFixed(4));
      this.words.forEach((word, i) => {
        const d = smooth(between(p,.045+i*.016,.285+i*.016));
        word.style.opacity = (1-d).toFixed(4);
        word.style.transform = `translate3d(${(d*d*(95+i*9)).toFixed(2)}px,${(-d*(22+i*2)).toFixed(2)}px,0) scale(${(1+d*.09).toFixed(3)})`;
        word.style.filter = `blur(${(d*d*13).toFixed(2)}px)`;
      });
      this.displacement.setAttribute('scale', (smooth(between(p,.06,.35))*36).toFixed(2));
      this.phrases.forEach((phrase,i) => {
        const r = smooth(between(p,.48+i*.085,.625+i*.085));
        phrase.style.opacity = r.toFixed(4);
        phrase.style.transform = `translate3d(0,${((1-r)*22).toFixed(2)}px,0)`;
      });
      this.support.inert = support < .15;
      this.root.dataset.openingState = p < .04 ? 'smoke' : p < .42 ? 'dispersing' : p < .8 ? 'connecting' : 'connected';
    }
    destroyEffects() {
      this.fog?.destroy();this.net?.destroy();this.fog=null;this.net=null;
    }
    destroy() {
      this.disposed = true;
      window.removeEventListener('scroll',this.queue);
      window.removeEventListener('resize',this.measure);
      this.motion.removeEventListener('change',this.configure);
      this.resizeObserver.disconnect();
      if(this.frame)cancelAnimationFrame(this.frame);
      this.destroyEffects();
      delete this.root.vsOpening;
    }
  }
  const init = (scope=document) => scope.querySelectorAll('[data-vs-opening]').forEach(root=>{if(!root.vsOpening)root.vsOpening=new VSOpening(root);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-vs-opening]').forEach(root=>root.vsOpening?.destroy()));
})();


  } catch(e) { console.error(e); }
})();
})();
